<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="(tab, index) in productStatusList" :label="tab.desc" :key="index">
            </el-tab-pane>
        </el-tabs>
        <el-form ref="searchForm" :model="searchData" inline>
            <el-form-item label="产品名称">
                <el-input size="mini" placeholder="请填写产品名称" v-model="searchData.name"></el-input>
            </el-form-item>
            <el-form-item label="产品类型">
                <el-select v-model="searchData.type" size="mini" placeholder="请选择" class="policy-box-input">
                    <el-option
                        v-for="(opt, key, index) in productTypeList"
                        :key="index"
                        :label="opt.desc"
                        :value="opt.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="供应链">
                <el-select v-model="searchData.supply_chain_id" size="mini" placeholder="请选择" class="policy-box-input">
                    <el-option
                        v-for="(opt, key, index) in supplyChainList"
                        :key="index"
                        :label="opt.name"
                        :value="opt.id">
                    </el-option>
                </el-select>
            </el-form-item>
<!--            <el-form-item label="是否需要供应链信息">
                <el-select v-model="searchData.need_supply_chain" size="mini" placeholder="请选择" class="policy-box-input">
                    <el-option
                        v-for="(opt, key, index) in unbindOptions"
                        :key="index"
                        :label="opt.label"
                        :value="opt.value">
                    </el-option>
                </el-select>
            </el-form-item>-->
            <el-form-item>
                <el-button size="mini" @click="handlerSearch">
                    查找
                </el-button>
            </el-form-item>
        </el-form>
        <el-table :data="dataList">
            <el-table-column
                prop="weight"
                label='排序ID'
            >
                <template slot-scope="scope">
                    <el-input v-model.number="scope.row.weight" :placeholder="scope.row.weight" size="mini" style="width: 80px;margin: 0 10px 0 0;" />
                    <el-button size="mini" type="primary" @click="updateWeight(scope.row)">提交</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="id" label="产品ID"/>
            <el-table-column prop="name" label="产品名"/>
            <el-table-column prop="type" label="产品类型">
                <template slot-scope="scope">
                    {{ getProductType(scope.row.type) }}
                </template>
            </el-table-column>
<!--            <el-table-column prop="status" label="产品状态">
                <template slot-scope="scope">
                    {{ getProductStatus(scope.row.status) }}
                </template>
            </el-table-column>-->
            <el-table-column label="保险公司">
                <template slot-scope="scope">
                    {{ getCompanyName(scope.row.company_id) }}
                </template>
            </el-table-column>
            <el-table-column label="关联产品">
                <template slot-scope="scope">
                    <span v-for="(v, i) in scope.row.supply_chains" :key="i">
                        <span v-if="i !== 0" style="margin: 0 5px;">|</span> 
                        <span :class="v.status === 2 ? 'colorRed' : ''">{{ getSupplyChain(v.supply_chain_id) }}</span>
                    </span>
                    <el-button type="primary" size="mini" style="margin: 0 0 0 10px;" @click="handleSupplyChainClick(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
            <el-table-column
                prop="user_id"
                label="操作"
            >
                <template slot-scope="scope">
                    <div class="edit-btn-box">
                        <el-button size="mini" @click="handleSettingRate(scope.row)" type="primary">设置佣金</el-button>
                        <el-button size="mini" @click="handleUploadShow(scope.row)" type="primary">上传附件</el-button>
                        <el-button size="mini" @click="handleProductDetailShow(scope.row)" type="primary">查看详情</el-button>
                        <el-button size="mini" @click="handleGetUserProductUrl(scope.row)" type="primary">指定用户链接</el-button>
                        <el-button size="mini" @click="handleGetExtensionProductUrl(scope.row)" type="primary">产品推广链接</el-button>
                        <el-button v-if="scope.row.status !== 3" size="mini" @click="updateStatus(scope.row)" type="primary">{{ scope.row.status === 1 ? '下架' : '上架' }}</el-button>
                        <el-button v-if="scope.row.status === 3" size="mini" @click="updateStatus(scope.row, 1)" type="primary">上架</el-button>
                        <el-button v-if="scope.row.status === 3" size="mini" @click="updateStatus(scope.row, 2)" type="primary">下架</el-button>
                        <el-button size="mini" @click="uploadPoster(scope.row)" type="primary">产品海报</el-button>
                        <el-button size="mini" @click="uploadArticle(scope.row)" type="primary">测评文章</el-button>
                        <el-button size="mini" @click="uploadSpeechcraft(scope.row)" type="primary">推荐话术</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page-bar
            ref="pageBar"
            :pageSize="20"
            :pageSizes="pageSizes"
            :currentPageCount="dataList.length"
            :sort="sort"
            @page-changed="loadData"
        ></page-bar>
        <el-dialog :visible.sync="productDetailShow">
            <el-form ref="detailData" :model="detailData" label-width="100px">
                <el-form-item label="ID："><el-input v-model="detailData.id" size="small" disabled /></el-form-item>
                <el-form-item label="产品名称："><el-input v-model="detailData.name" size="small" disabled /></el-form-item>
                <el-form-item label="产品类型："><el-input :value="getProductType(detailData.type)" size="small" disabled /></el-form-item>
                <el-form-item label="产品卖点："><el-input v-model="detailData.selling_points" size="small" disabled /></el-form-item>
                <el-form-item label="保障责任：">
                    <el-input size="small" disabled v-for="(desc, index) in detailData.description" :value="desc" :key="index"/>
                </el-form-item>
                <el-form-item label="保险公司："><el-input :value="getCompanyName(detailData.company_id)" size="small" disabled /></el-form-item>
                <el-form-item label="等待期："><el-input v-model="detailData.waiting_period" size="small" disabled /></el-form-item>
                <el-form-item label="犹豫期："><el-input v-model="detailData.cooling_off_period" size="small" disabled /></el-form-item>
                <el-form-item label="投保年龄："><el-input v-model="detailData.requirement_age" size="small" disabled /></el-form-item>
                <el-form-item label="投保职业："><el-input v-model="detailData.requirement_occupation" size="small" disabled /></el-form-item>
                <el-form-item label="保额："><el-input v-model="detailData.amount" size="small" disabled /></el-form-item>
                <el-form-item label="交费方式："><el-input v-model="detailData.pay_method_options" size="small" disabled /></el-form-item>
                <el-form-item label="保障期限："><el-input v-model="detailData.valid_period_options" size="small" disabled /></el-form-item>
                <el-form-item label="供应链信息：">
                    <el-input v-for="(v,i) in detailData.supply_chains" :value="v.name" :key="i" size="small" disabled />
                </el-form-item>
                <el-form-item label="扩展信息：">
                    <el-form-item label="推荐话术：" label-width="150px" style="margin-bottom: 10px;"><el-input type="textarea" v-model="productExtra.recommend_document" size="small" disabled /></el-form-item>
                    <el-form-item label="测评文章标题：" label-width="150px"><el-input v-model="productExtra.evaluation_article_title" size="small" disabled /></el-form-item>
                    <el-form-item label="测评文章链接：" label-width="150px"><el-input v-model="productExtra.evaluation_article_url" size="small" disabled /></el-form-item>
                    <el-form-item label="海报类型：" label-width="150px" v-if="productExtra.poster_url"><el-input :value="getPosterType(productExtra.poster_type)" size="small" disabled /></el-form-item>
                    <el-form-item label="海报：" label-width="150px" v-if="productExtra.poster_url"><el-image :src="productExtra.poster_url" size="small" disabled /></el-form-item>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="productDetailShow = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose">
            <span>确定要修改此产品状态吗？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible  = false">取 消</el-button>
                <el-button type="primary" @click="updateStatusProduct">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="关联产品"
            :visible.sync="supplyChainDialogShow"
            width="40%"
            :before-close="handleSupplyChainDialogClose">
            <div  v-for="(v, i) in supplyChain" :key="i">
                <div class="supplyChainBox">
                    <span>{{ getSupplyChain(v.supply_chain_id) }}:</span>
                    <span>{{ v.name }}</span>
                    <span>{{ getSupplyChainProductStatus(v.status) }}</span> 
                    <el-button size="mini" type="primary" @click="handleUnbindProductClick(v)">解除关联</el-button>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="supplyChainDialogShow  = false" type="primary">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="unbindConfirmDialogShow"
            width="30%"
            :before-close="handleUnbindConfirmClose">
            <span>确定要解除此产品吗？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="unbindConfirmDialogShow  = false">取 消</el-button>
                <el-button type="primary" @click="unbindClick">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="上传附件"
            :visible.sync="uploadDialogShow"
            width="60%"
            :before-close="handleUploadDialogClose">
            <div class="box-info">
                <div class="upload-box" v-for="(item, index) in uploadFileList" :key="index">
                    <span class="upload-title">{{ item.title }}</span>
                    <div class="file-box">
                        <div class="file" v-for="(file, i) in item.files" :key="i"><span>{{ file.filename }}</span><span class="delete-txt" @click="handleUpdateProductAppendix(file)">删除</span></div>
                    </div>
                    <Uploader :fileList="item" :uploadType="item.type" @handleChangeUpload="handleChangeUpload" :uploadProduct="uploadProduct"></Uploader>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="uploadDialogShow  = false">取 消</el-button>
                <el-button type="primary" @click="upload">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="测评文章"
            :visible.sync="articleDialogShow"
            width="30%"
            :before-close="handleArticleDialogClose">
            <div class="box-info">
                <div class="article-box">
                    <el-form class="box-margin">
                        <el-form-item label="文章标题：">
                            <el-input size="small" v-model="article.title"></el-input>
                        </el-form-item>
                        <el-form-item label="文章链接：">
                            <el-input size="small" v-model="article.url"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleArticleDialogClose">取 消</el-button>
                <el-button type="primary" @click="editArticle">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="推荐话术"
            :visible.sync="speechArtDialogShow"
            width="30%"
            :before-close="handleSpeechArtDialogClose">
            <div class="box-info">
                <div class="article-box">
                    <el-form class="box-margin">
                        <el-form-item label="推荐话术：">
                            <el-input type="textarea" size="small" v-model="speechArt"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleSpeechArtDialogClose">取 消</el-button>
                <el-button type="primary" @click="editSpeechArt">确 定</el-button>
            </span>
        </el-dialog>
<!--     产品海报    -->
        <el-dialog
            title="产品海报"
            :visible.sync="productPosterDialogShow"
            width="30%"
            destroy-on-close
            :before-close="handleProductPosterDialogClose">

            <el-select v-model="uploadPosterType" size="mini" placeholder="请选择" class="policy-box-input">
                <el-option
                    v-for="(opt, key, index) in supplyChains"
                    :key="index"
                    :label="opt.desc"
                    :value="opt.type">
                </el-option>
            </el-select>
            <el-button type="primary" size="mini" style="margin: 0 20px;" @click="handleDeletePoster" v-if="posterDetail.url">删除</el-button>
            <!--                    <Uploader :fileList="item" :uploadType="item.type" @handleChangeUpload="handleChangeUpload" :uploadProduct="uploadProduct"></Uploader>-->
            <UploadPoster :fileList="posterList" :type="uploadPosterType" @handleChangePosterUpload="handleChangePosterUpload" :id="currentId" :posterDetail="posterDetail"></UploadPoster>
           
            <span slot="footer" class="dialog-footer">
<!--                <el-button @click="handleProductPosterDialogClose">取 消</el-button>-->
                <el-button type="primary" @click="handleProductPosterDialogClose">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            :title="getProductUrlType === 1 ? '获取投保链接' : '获取推广链接'"
            :visible.sync="userProductUrlDialogShow"
            width="30%"
            :before-close="handleUserProductUrlDialogClose">

            <el-form ref="detailData" :model="currentProduct" label-width="100px">
                <el-form-item label="产品ID："><el-input v-model="currentProduct.id" size="small" disabled /></el-form-item>
                <el-form-item label="用户ID："><el-input v-model="currentUserId" size="small" /></el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="userProductUrlDialogShow  = false">取 消</el-button>
                <el-button type="primary" @click="handleGetProductUrl">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="投保链接"
            :visible.sync="userProductUrlTableDialogShow"
            :before-close="handleUserProductUrlTableDialogClose">
            <el-table :data="userProductUrlTable">
                <el-table-column prop="id" label="产品ID" />
                <el-table-column prop="supply_chain_id" label="供应链" width="100px">
                    <template #default="scope">
                        {{getSupplyChain(scope.row.supply_chain_id)}}
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="产品名称" />
                <el-table-column label="投保链接">
                    <template #default="scope">
                        <div>{{scope.row.link_url}}</div>
                        <el-button type="text" v-clipboard:copy="scope.row.link_url" v-clipboard:success="onSuccess" v-clipboard:error="onError">复制链接</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="投保二维码" >
                    <template #default="scope">
                        <div class="qrcode-box" v-show="scope.row.qrcode">
                            <el-image :src="scope.row.qrcode"></el-image>
                            <a :href="scope.row.qrcode" :download="scope.row.name">下载二维码</a>
                        </div>
                        <div class="btn" v-show="!scope.row.qrcode" @click="getQRCode(scope.row,scope.$index, 1)">
                            <el-button type="text">查看二维码</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleUserProductUrlTableDialogShow">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="推广链接"
            :visible.sync="extensionProductUrlTableDialogShow"
            :before-close="handleExtensionProductUrlTableDialogClose">
            <el-table :data="extensionProductUrlTable">
                <el-table-column prop="id" label="产品ID" />
                <el-table-column prop="supply_chain_id" label="供应链" width="100px">
                    <template #default="scope">
                        {{getSupplyChain(scope.row.supply_chain_id)}}
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="产品名称" />
                <el-table-column label="推广链接">
                    <template #default="scope">
                        <div>{{scope.row.link_url}}</div>
                        <el-button type="text" v-clipboard:copy="scope.row.link_url" v-clipboard:success="onSuccess" v-clipboard:error="onError">复制链接</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="推广二维码" >
                    <template #default="scope">
                        <div class="qrcode-box" v-show="scope.row.qrcode">
                            <el-image :src="scope.row.qrcode"></el-image>
                            <a :href="scope.row.qrcode" :download="scope.row.name">下载二维码</a>
                        </div>
                        <div class="btn" v-show="!scope.row.qrcode" @click="getQRCode(scope.row,scope.$index, 2)">
                            <el-button type="text">查看二维码</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleExtensionProductUrlTableDialogClose">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="设置佣金"
            width="80%"
            :visible.sync="settingRateDialogShow"
            :close-on-click-modal="false"
            v-if="settingRateDialogShow"
            :before-close="handleSettingRateDialogDialogClose">
            <SettingRate :productId="currentId" :tableHistory="tableHistory" @getSettingRateData="getSettingRateData" @getSettingRateDataChooseTimerRange="getSettingRateDataChooseTimerRange" @getSettingRateDataRemark="getSettingRateDataRemark" @getSettingRateDataVersion="getSettingRateDataVersion"></SettingRate>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleSettingRateDialogDialogClose">取 消</el-button>
                <el-button @click="settingRateConfirmDialogShow = !settingRateConfirmDialogShow" type="primary">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="settingRateConfirmDialogShow"
            width="30%"
            :before-close="handleClose">
            <span>确定要设置此产品佣金吗？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="settingRateConfirmDialogShow  = false">取 消</el-button>
                <el-button type="primary" @click="handleSettingRateConfirm">确 定</el-button>
            </span>
        </el-dialog>
        <div id="qrcode" ref="qrCodeDiv" class="qrcode"></div>
    </div>
</template>
<script>
import PageBar from '../ui/PageBar'
import request from "@/api/request"
import Uploader from './Uploader.vue'
import UploadPoster from './UploadPoster.vue'
import SettingRate from "./SettingRate.vue"
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";

const unbindOptions = [{label: '是', value: 1},{label: '否', value: 2}]
export default {
    components: {
        PageBar,
        Uploader,
        SettingRate,
        UploadPoster
    },
    data(){
        return {
            productExtra: {},
            posterList: [],
            posterType: 'image/*',
            pageSizes: [10, 20, 50],
            dataList: [],
            detailData: {},
            filter: {
                status: [1],
                need_supply_chain: true,
                name: ''
            },
            productTypeList: [],
            productStatusList: [],
            companyOptions: [],
            supplyChainList: [],
            supplyChainProductStatusList: [],
            tabIndex: 0,
            activeName: '',
            productDetailShow: false,
            supplyChainDialogShow: false,
            unbindConfirmDialogShow: false,
            uploadDialogShow: false,
            articleDialogShow: false,
            userProductUrlDialogShow: false,
            supplyChain: [], //关联产品
            currentRange: [0, 20],
            searchData: {
                supply_chain_id: '',
                need_supply_chain: true,
                type: '',
                name: ''
            },
            sort: [
                {
                    field: 'weight',
                    reverse: true
                }
            ],
            unbindOptions,
            status: 1,
            dialogVisible: false,
            updateProductInfo: {},
            unbindData: {},
            uploadFileList: [
                {title: '产品介绍', type: 1, files: [],},
                {title: '保险条款', type: 2, files: []},
                {title: '健康告知', type: 3, files: []},
                {title: '投保规则', type: 4, files: []},
                {title: '费率表', type: 5, files: []},
                {title: '现金价值', type: 6, files: []},
                {title: '投保须知', type: 7, files: []},
                {title: '职业表', type: 8, files: []},
                {title: 'Q&A', type: 9, files: []},
                {title: '投保告知', type: 10, files: []},
                {title: '支持银行', type: 11, files: []},
                {title: '理赔', type: 12, files: []},
                {title: '保全', type: 13, files: []},
                {title: '公司介绍', type: 14, files: []},
                {title: '附加服务', type: 15, files: []},
            ],
            uploadPosterFileList: [
                {title: 'YB', type: 1, files: []},
                {title: 'HZ', type: 2, files: []},
                {title: 'YS', type: 3, files: []},
                {title: 'WT', type: 4, files: []},
            ],
            article: {
                title: '',
                url: ''
            },
            currentFiles: [],
            uploadType: '',
            uploadProduct: {},
            currentProduct: {},
            currentUserId: '',
            userProductUrlTableDialogShow: false,
            userProductUrlTable: [],
            extensionProductUrlTableDialogShow: false,
            settingRateDialogShow: false,
            settingRateConfirmDialogShow: false,
            extensionProductUrlTable: [],
            initOpt: {value: 999, desc: '全部'},
            initOpt1: {id: 999, name: '全部'},
            getProductUrlType: 1,//1,投保链接；2，推广链接
            currentId: null,
            settingRateData: [],
            count: 1,
            chooseTimerRange: [],
            remark: '',
            version: '',
            tableHistory: [],
            posterDialogShow: false,
            speechArtDialogShow: false,
            speechArt: '',
            productPosterDialogShow: false,
            uploadPosterFile: {},
            productPoster: {
                url: '',
                type: 0
            },
            supplyChains: [{type: 1, desc: 'YB'}, {type: 2, desc: 'HZ(距底宽)'},{type: 3, desc: 'YS'},{type: 4, desc: 'WT'},{type: 5, desc: 'HZ(距底窄)'}],
            //supplyChains: [{type: 1, desc: 'YB'}, {type: 2, desc: 'HZ'},{type: 3, desc: 'YS'}],
            uploadPosterType: null,
            posterDetail: {
                url: '',
                type: 0
            }
        }
    },
    created() {
        this.initData()
        this.loadData([0, 20])
    },
    mounted() {
        document.querySelector('#app').setAttribute('style', 'background-color:#FFFFFF')
    },
    methods: {
        handleDeletePoster(){
            this.posterList = []
            request.saas
                .post("product/upload_product_poster", {
                    url: '',
                    type: this.uploadPosterType,//this.productPoster.type,
                    product_main_id: String(this.currentId)
                })
                .then(() => {
                    let file = {
                        type: this.type,
                        name: '',
                        url: ''
                    }
                    this.posterDetail.url = ''
                    this.posterList.push(file)
                    console.log(this.posterList)
                    this.$message.success('删除成功')
                })
        },
        getPosterType(type){
            let typeOpt = ['云服', '齐欣', '牛保', '凤栖']
            return typeOpt[type-1]
        },
        getProductExtraInfo(){
            this.posterList = []
            request.saas
                .post("product/get_product_extra", {
                    product_id: String(this.currentId)
                })
                .then(res => {
                    //console.log(res)
                    this.productExtra = res.data
                    this.speechArt = res.data.recommend_document
                    this.article.title = res.data.evaluation_article_title
                    this.article.url = res.data.evaluation_article_url
                    this.productPoster.url = res.data.poster_url
                    this.productPoster.type = res.data.poster_type
                    let poster = {
                        url: res.data.poster_url,
                        type: res.data.poster_type,
                        name: res.data.poster_url
                    }
                    this.posterList.push(poster)
                    this.posterType - res.data.poster_type
                    this.posterDetail.url = res.data.poster_url
                    this.posterDetail.type = res.data.poster_type
                    this.uploadPosterType = res.data.poster_type ? res.data.poster_type : null
                })  
        },
        uploadSpeechcraft(item) {
            this.currentId = item.id
            this.getProductExtraInfo()
            this.speechArtDialogShow = !this.speechArtDialogShow
        },
        uploadPoster(item) {
            this.currentId = item.id
            this.getProductExtraInfo()
            this.handleProductPosterDialogClose()
        },
        uploadArticle(item) {
            this.currentId = item.id
            this.getProductExtraInfo()
            this.articleDialogShow = !this.articleDialogShow
        },
        editSpeechArt(){
            //推荐话术
            request.saas
                .post("product/update_product_recommend_document", {
                    product_id: String(this.currentId),
                    recommend_document: this.speechArt
                })
                .then(() => {
                    this.$message.success('设置成功')
                    this.handleSpeechArtDialogClose()
                })
        },
        handleSpeechArtDialogClose(){
            this.speechArtDialogShow = !this.speechArtDialogShow
            this.speechArt = ''
        },
        handleProductPosterDialogClose(){
            this.productPosterDialogShow = !this.productPosterDialogShow  
        },
        loadData(range){
            this.currentRange = range
            request.saas
                .post('product/get_product_list', { filter: this.filter, range: range })
                .then(r => {
                this.dataList = r.data.list
            })
        },
        initData(){
            //获取供应链产品状态信息.在售/停售
            request.saas
                .post("product/supply_chain_product_status_list", {})
                .then(resp => {
                    this.supplyChainProductStatusList = resp.data.list
                })
            //获取供应链信息
            request.saas
                .post("product/supply_chain_list", {})
                .then(resp => {
                    this.supplyChainList = resp.data.list
                    this.supplyChainList.unshift(this.initOpt1)
                })
            //获取产品类型信息
            request.saas
                .post("product/product_type_list", {})
                .then(resp => {
                    this.productTypeList = resp.data.list
                    this.productTypeList.unshift(this.initOpt)
                })
            //获取产品状态信息
            request.saas
                .post("product/product_status_list", {})
                .then(resp => {
                    this.productStatusList = resp.data.list
                })
            //获取公司名称列表
            request.product
                .post(
                    'company_list',
                    {
                        range: [0,1000]
                    }
                )
                .then(res => {
                    this.companyOptions = res.data.list
                })
        },
        handlerSearch: function() {
            //查找产品
            let filter = {};
            filter.status = [this.status]
            if (this.searchData.supply_chain_id && this.searchData.supply_chain_id !== 999) {
                filter.supply_chain_id = [parseInt(this.searchData.supply_chain_id)]
            }
            if(this.searchData.type  && this.searchData.type !== 999) {
                filter.type = [this.searchData.type]
            }

            if(this.searchData.name) {
                filter.name = this.searchData.name
            }
            filter.need_supply_chain = true
            
            this.filter = filter
            this.loadData(this.currentRange)
        },
        handleClick(tab){
            //tab切换
            this.tabIndex = tab.index
            this.status = this.productStatusList[tab.index].value
            this.filter ={
                status: [this.status],
                need_supply_chain: true
            }
            this.dataList = []
            this.searchData = {
                supply_chain_id: '',
                need_supply_chain: true,
                type: ''
            }
            this.loadData(this.currentRange)
        },
        handleProductDetailShow(product) {
            //查看产品详细信息
            this.currentId = product.id
            this.getProductExtraInfo()
            this.detailData = product
            
            this.productDetailShow = true
        },
        handleSettingRate(item) {
            //设置佣金
            request.saas
                .post("product/get_product_fee_table_history", {
                    product_id: String(item.id)
                })
                .then(res => {
                    //console.log(res)
                    this.tableHistory = res.data.list
                })
            //console.log(item)  
            this.currentId = item.id
            this.settingRateDialogShow = !this.settingRateDialogShow
        },
        handleSettingRateConfirm(){
            //调接口
            this.handleDealSettingRateData()
            //console.log(222222222, this.settingRateData)
            
        },
        handleDealSettingRateData(){

            let check = true
            let data = this.settingRateData
            console.log(data, 111111)
            let rate = []
            let nameInit = data[0].name
            let bzqxInit = data[0].bzqxType === 1 ? { type: 1 } : { type: Number(data[0].bzqxType), year: Number(data[0].bzqx) }
            
            // eslint-disable-next-line no-unused-vars
            let a = {
                name: nameInit,
                bzqx: {
                    valid_period: bzqxInit
                }
            }
            
            //let last_row = {}
            data.map(item => {
                console.log('item', item)
                let row = {}
                let nodes = []
                
                for(let i = 1; i <= this.count; i++){
                    let node = {
                        year: i,
                        ratio: item[`year${i}`] ? this.accMul(item[`year${i}`], 100) : 0,
                        activity_ratio: item[`activity${i}`] ? this.accMul(item[`activity${i}`], 100) : 0
                    }
                    //console.log(node)
                    nodes.push(node)
                }

                if(!item.bzqxType || !item.jfqxType) {
                    check = false
                }
                if(item.bzqxType !== 1 && !item.bzqx && !item.bzqxDetailType){
                    check = false
                }
                if(item.jfqxType !== 1 && !item.jfqx){
                    check = false
                }
                let detailType = [item.bzqxDetailType === 1 || item.bzqxDetailType ==='年' ? 'year' : item.bzqxDetailType === 2 || item.bzqxDetailType === '月' ? 'month' : 'day']
                
                row = {
                    name: item.name,
                    valid_periods: [
                        {
                            valid_period: item.bzqxType === 1 ? { type: 1 } : { type: item.bzqxType, [`${detailType}`] : Number(item.bzqx) }, //保障期限
                            pay_methods: [{
                                pay_method: item.jfqxType === 1 ? { type: 1 } : { type: item.jfqxType, year: Number(item.jfqx) },
                                nodes: nodes
                            }]
                        },
                    ]
                }
                //console.log('row', row, rate)
                let len = rate.length
                if(len < 1) {
                    rate.push(row)
                } else {
                    let rateLen = rate.length
                    for(let i = 0; i < rateLen; i++) {
                        let last = rate[i]
                        if(last.name === row.name) {
                            let valid_periods = last.valid_periods
                            for(let j = 0; j < valid_periods.length; j++) {
                                console.log(valid_periods[j])
                                if(valid_periods[j].valid_period.type === row.valid_periods[0].valid_period.type) {
                                    if(valid_periods[j].valid_period.type === 1 && row.valid_periods[0].valid_period.type === 1) {
                                        valid_periods[j].pay_methods.push(row.valid_periods[0].pay_methods[0])
                                        break
                                    } else {
                                        if(valid_periods[j].valid_period.hasOwnProperty(detailType) && valid_periods[j].valid_period[`${detailType}`] === row.valid_periods[0].valid_period[`${detailType}`]){
                                            valid_periods[j].pay_methods.push(row.valid_periods[0].pay_methods[0])
                                            break
                                        } else {
                                            last.valid_periods.push(row.valid_periods[0])
                                            break
                                        }
                                    }
                                } else {
                                    
                                    last.valid_periods.push(row.valid_periods[0])
                                    break
                                }
                            }
                        } else {
                            rate.push(row)
                            break
                        }
                    }
                }
            })
            
            console.log('rate save', rate)
            //console.log(JSON.stringify(rate))

            if(check) {
                this.setRate({
                    column_count: this.count,
                    products: rate
                }) 
            } else {
                this.settingRateConfirmDialogShow = !this.settingRateConfirmDialogShow
                this.$message.error('请检查数据')
            }
        },
        accMul(arg1, arg2) {
            var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
            try {
                m += s1.split(".")[1].length;
            }
                // eslint-disable-next-line no-empty
            catch (e) {

            }
            try {
                m += s2.split(".")[1].length;
            }
                // eslint-disable-next-line no-empty
            catch (e) {
            }
            return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
        },
        setRate(rate) {
            let data = {
                product_id: String(this.currentId),
                table: JSON.stringify(rate),
                activity_start_time: this.chooseTimerRange[0],
                activity_end_time: this.chooseTimerRange[1],
                version: this.version,
                remark: this.remark
            }
            //console.log(data)

            request.saas
                .post("product/update_product_fee_table", data)
                .then(() => {
                    this.$message.success('设置成功')
                    this.loadData(this.currentRange)
                    this.settingRateConfirmDialogShow = false
                    this.settingRateDialogShow = false
                })
        },
        getSettingRateData(table, count){
            
            this.settingRateData = table
            this.count = count
            /*this.remark = data.remark
            this.version = data.version
            this.chooseTimerRange = data.chooseTimerRange*/
        },
        getSettingRateDataRemark(remark) {
            this.remark = remark
        },
        getSettingRateDataVersion(version) {
            this.version = version
        },
        getSettingRateDataChooseTimerRange(chooseTimerRange) {
            this.chooseTimerRange = chooseTimerRange
        },
        
        handleSettingRateDialogDialogClose(){
            this.settingRateDialogShow = !this.settingRateDialogShow  
        },
        handleSupplyChainClick(detail) {
            this.supplyChain = detail.supply_chains
            this.supplyChainDialogShow = true
        },
        handleUnbindProductClick(v){
            //解除关联
            this.unbindData = {
                product_id: v.id, //供应链产品id
                supply_chain_id: v.supply_chain_id, //供应链id	
                product_main_id: 0 // 0表示解绑
            }
            this.unbindConfirmDialogShow = true
        },
        unbindClick(){
            //解除关联
            request.saas
                .post("product/bind_supply_chain_product", this.unbindData)
                .then(() => {
                    this.$message.success('解绑成功')
                    this.loadData(this.currentRange)
                    this.supplyChainDialogShow = false
                    this.unbindConfirmDialogShow = false
                })
        },
        updateWeight(p){
            //修改产品权重
            request.saas
                .post("product/update_product_weight", {
                    id: p.id,
                    weight: p.weight
                })
                .then(() => {
                    this.$message.success('修改成功')
                    this.loadData(this.currentRange)
                })
        },
        updateStatus(item, s){
            let status = s ? s : item.status === 1 ? 2 : 1
            console.log(status)
            this.updateProductInfo = {
                id: item.id,
                status: status
            }
            this.dialogVisible = true
        },
        updateStatusProduct(){
            //修改产品状态
            request.saas
                .post("product/update_product_status", this.updateProductInfo )
                .then(() => {
                    this.$message.success('修改成功')
                    this.loadData(this.currentRange)
                    this.dialogVisible = false
                })
        },
        getSupplyChain(id){
            //获取产品供应链
            for (const opt of this.supplyChainList) {
                if(id === opt.id) {
                    return opt.name
                }
            }
        },
        getProductType(type){
            //获取产品类型
            for (const opt of this.productTypeList) {
                if(type === opt.value) {
                    return opt.desc
                }
            }
        },
        getCompanyName(id){
            //获取公司名称
            for(const c of this.companyOptions) {
                if(id === c.id) {
                    return c.name
                }
            }
        },
        getProductStatus(status){
            //获取产品状态，上架、下架
            for (const opt of this.productStatusList) {
                if(status === opt.value) {
                    return opt.desc
                }
            }
        },
        getSupplyChainProductStatus(status){
            //在售、停售
            for (const opt of this.supplyChainProductStatusList) {
                if(status === opt.value) {
                    return opt.desc
                }
            }
        },
        handleClose(){
            this.dialogVisible = !this.dialogVisible
        },
        handleSupplyChainDialogClose(){
            this.supplyChainDialogShow = !this.supplyChainDialogShow
        },
        handleUnbindConfirmClose(){
            this.unbindConfirmDialogShow = !this.unbindConfirmDialogShow
        },
        handleUploadShow(cur){
            //上传文件dialog
            this.uploadFileList =  [
                {title: '产品介绍', type: 1, files: [],},
                {title: '保险条款', type: 2, files: []},
                {title: '健康告知', type: 3, files: []},
                {title: '投保规则', type: 4, files: []},
                {title: '费率表', type: 5, files: []},
                {title: '现金价值', type: 6, files: []},
                {title: '投保须知', type: 7, files: []},
                {title: '职业表', type: 8, files: []},
                {title: 'Q&A', type: 9, files: []},
                {title: '投保告知', type: 10, files: []},
                {title: '支持银行', type: 11, files: []},
                {title: '理赔', type: 12, files: []},
                {title: '保全', type: 13, files: []},
                {title: '公司介绍', type: 14, files: []},
                {title: '附加服务', type: 15, files: []},
            ]
            this.uploadProduct = cur
            request.saas
                .post("product/get_product_appendix_list", {
                    product_main_id: String(cur.id)
                } )
                .then((res) => {
                    //console.log('res', res.data.appendixes)
                    let appendixes = res.data.appendixes
                    this.uploadFileList.map(list => {
                        appendixes.map(item => {
                            if (list.type === item.type) {
                                list.files.push(item)
                            }
                        })
                    })
                    
                })
            this.handleUploadDialogClose()
        },
        handleUpdateProductAppendix(file){
            request.saas
                .post("product/update_product_appendix", {
                    id: file.id,
                    type: file.type,
                    filename: file.filename,
                    status: 2
                })
                .then(() => {
                    this.uploadFileList.map((list) => {
                        list.files.map((item, index) => {
                            if (item.type === file.type) {
                                list.files.splice(index, 1)
                            }
                        })
                    })
                    this.$message.success('删除成功')
                })
        },
        handleUploadDialogClose(){
            this.uploadDialogShow = !this.uploadDialogShow
        },
        
        uploadPosterInterface(){
            //上传产品海报
            this.productPosterDialogShow = !this.productPosterDialogShow
        },
        handleChangeUpload(file){
            this.uploadFileList.map(item => {
                if (item.type === file.type) {
                    item.files.push(file)
                }
            })
        },
        handleChangePosterUpload(file){
            this.posterList[0] = file
        },
        upload(){
            this.handleUploadDialogClose()
        },
        handleArticleDialogClose(){
            this.articleDialogShow = !this.articleDialogShow
            this.article = {
                title: '',
                url: ''
            }
        },
        editArticle(){
            //测评文章
            request.saas
                .post("product/update_product_evaluation_article", {
                    product_id: String(this.currentId),
                    evaluation_article_title: this.article.title,
                    evaluation_article_url: this.article.url
                })
                .then(() => {
                    this.$message.success('设置成功')
                    this.handleArticleDialogClose()
                })
        },
        handleGetExtensionProductUrl(item){
            //推广链接
            
            //console.log(item.supply_chains)
            this.currentUserId = ''
            this.currentProduct = item
            this.extensionProductUrlTable = []
            this.getProductUrlType = 2
            let arr = item.supply_chains
            this.$message.info('请稍等')
            let host_url = window.location.href
            let host_url1 = ''
            if (host_url.includes('vm33')) {
                host_url1 = 'http://msaas.vm33.finadv.cn/extension?channelCode=7ea75eec843544cf9b3cce5dac022a8c' //vm33
            } else if(host_url.includes('uat')){
                host_url1 = 'https://msaas.uat.finadv.cn/extension?channelCode=7ea75eec843544cf9b3cce5dac022a8c' //uat
            } else {
                host_url1 = 'https://msaas.tling.vip/extension?channelCode=263d122a20f94f94a733b14268d3c93c' //线上
            }
            arr.map(ite=> {
                ite.link_url = host_url1 + '&supplyId=' + ite.supply_chain_id + '&productId=' + ite.id
                this.extensionProductUrlTable.push(ite)
            })
            
            this.handleExtensionProductUrlTableDialogClose()
        },
        getQRCode(item, index, type){
            //console.log(index)
            //type: 1,投保；2，推广
            this.$refs.qrCodeDiv.innerHTML = ''
            new QRCode("qrcode", {
                type: 'image/png',
                width: 500,
                height: 500,
                text: item.link_url, // 二维码地址
                colorDark: "#000",
                colorLight: "#fff",
                correctLevel : QRCode.CorrectLevel.H
            })
            html2canvas(this.$refs.qrCodeDiv, {
                useCORS: true,
                scale: 3,
                removeContainer: true
            }).then(canvas => {
                item.qrcode = canvas.toDataURL()
                if(type === 1){
                    this.userProductUrlTable[index].qrcode = canvas.toDataURL()
                    this.$set(this.userProductUrlTable[index], item)
                } else {
                    this.extensionProductUrlTable[index].qrcode = canvas.toDataURL()
                    this.$set(this.extensionProductUrlTable[index], item)
                }
            });
            
            
        },
        handleGetUserProductUrl(item) {
            //投保链接
            this.currentUserId = ''
            this.currentProduct = item
            this.getProductUrlType = 1
            this.handleUserProductUrlDialogClose()
        },
        handleUserProductUrlDialogClose() {
            this.userProductUrlDialogShow = !this.userProductUrlDialogShow
        },
        handleGetProductUrl(){
            if(!this.currentUserId) return
            this.userProductUrlTable = []
                //投保
            request.saas
                .post("product/get_supply_chain_product_link_url", {
                    user_id: this.currentUserId,
                    product_main_id: String(this.currentProduct.id)
                })
                .then(resp => {
                    if(!resp.data.list) return
                    this.userProductUrlTable = resp.data.list
                    this.$nextTick(() => {
                        this.handleUserProductUrlTableDialogClose()
                    })
                })
            
        },
        handleUserProductUrlTableDialogClose() {
            this.userProductUrlTableDialogShow = !this.userProductUrlTableDialogShow
            this.handleUserProductUrlDialogClose()
            
        },
        handleUserProductUrlTableDialogShow(){
            this.handleUserProductUrlTableDialogClose()
            this.handleUserProductUrlDialogClose()
        },
        handleExtensionProductUrlTableDialogClose(){
            this.extensionProductUrlTableDialogShow = !this.extensionProductUrlTableDialogShow
        },
        onSuccess(){
            console.log('复制成功')
            this.$message.success('复制成功')
        },
        onError(){
            console.log('复制失败')
        }
    }
}
</script>
<style scoped>
#app{
    background: #FFFFFF;
}
.supplyChainBox{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 10px 0 0;
}
.supplyChainBox span{
    margin: 0 15px 0 0;
}
.colorRed{
    color: red;
}
>>> .dialog-footer.el-button{
    margin-right: 10px;
}
.edit-btn-box{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
}
.edit-btn-box .el-button{
    width: calc(50% - 20px);
    margin: 10px 20px 0 0;
    padding: 7px 0;
}
.upload-box{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    margin: 10px 0 10px 28px;
    font-size: 14px;
}
.upload-title{
    width: 100px;
}
.upload-box span{
    margin: 0 20px 0 0;
}
.delete-txt{
    color: #409EFF;
}
.qrcode {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 500px;
    text-align: center;
    margin: 20px auto;
}
.qrcode img{
    width: 100%;
    height: 100%;
}
.qrcode-box{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.qrcode-box a{
    margin-top: 20px;
    text-decoration: none;
    color: #409EFF;
    font-size: 14px;
}
</style>
